import { render } from "./MeasureResult.vue?vue&type=template&id=c8ff0744"
import script from "./MeasureResult.vue?vue&type=script&lang=js"
export * from "./MeasureResult.vue?vue&type=script&lang=js"

import "./MeasureResult.vue?vue&type=style&index=0&id=c8ff0744&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__